import { Box } from '@mui/material'
import { ICheckupList } from 'models'
import moment from 'moment'
import { Dispatch, SetStateAction, useState } from 'react'
import DatePicker from 'ui/DatePickerInput/DatePicker'

import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
type NextExaminationBlock = {
	date: number
	setCheckupInfo: Dispatch<SetStateAction<ICheckupList>>
}

const NextExaminationBlock = (props: NextExaminationBlock) => {
	const { date, setCheckupInfo } = props
	const [selectDate, setSelectedDate] = useState(date)
	const clickDatePicker = date => {
		setSelectedDate(date)
		setCheckupInfo(prev => {
			return {
				...prev,
				next_examination_date: moment(date).valueOf(),
			}
		})
	}
	return (
		<Box
			display={'flex'}
			flexDirection={'row'}
			width={'100%'}
			alignItems={'flex-start'}
			gap={'40px'}
		>
			<Box width={'240px'}>
				<TypographyPrimary>
					Дата повторного
					<br />
					осмотра
				</TypographyPrimary>
			</Box>
			<DatePicker
				value={selectDate}
				onChange={newDate => clickDatePicker(newDate)}
			/>
		</Box>
	)
}

export default NextExaminationBlock
